import { VerticalContainer } from '@american-autonomy/ag-ui';

import Banner from 'components/Banner';

import useTranslation from './hooks/useTranslation';

import { LB_AI_DECIMAL_PRECISION, MIN_CONTRIBUTIONS_FOR_STACKING, TEST_ID } from './constants';
import type { AiLoadRow, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const formatTotal = (value: number | null): string =>
    value === null ? '—' : value.toFixed(LB_AI_DECIMAL_PRECISION);

const buildBannerText = (
    row: AiLoadRow,
    describeRow: (name: string, total: string) => string,
    exceedsCapBadge: string
): string => {
    const baseText = describeRow(row.name, formatTotal(row.totalLbAiPerAcre));

    if (row.exceedsSeasonCap) {
        return `${baseText} — ${exceedsCapBadge}`;
    }

    return baseText;
};

const SameAiWarningBanner: FunctionComponent<Props> = ({
    className = '',
    rows,
    testId = TEST_ID
}) => {
    const { EXCEEDS_CAP_BADGE, TITLE, description } = useTranslation();
    const stackedRows = rows.filter(
        row => row.contributions.length >= MIN_CONTRIBUTIONS_FOR_STACKING
    );

    if (stackedRows.length === 0) {
        return null;
    }

    const headerText = `${TITLE}${stackedRows.length > 1 ? ` (${stackedRows.length})` : ''}`;

    return (
        <VerticalContainer className={`${styles.sameAiWarningBanner} ${className}`} testId={testId}>
            <Banner text={headerText} variant='warn' />

            {stackedRows.map(row => (
                <Banner
                    icon='none'
                    key={row.casNumber}
                    text={buildBannerText(row, description, EXCEEDS_CAP_BADGE)}
                    variant={row.exceedsSeasonCap ? 'warn' : 'info'}
                />
            ))}
        </VerticalContainer>
    );
};

export default SameAiWarningBanner;
